import { render } from "./CartSideBar.vue?vue&type=template&id=9c9067b8"
import script from "./CartSideBar.vue?vue&type=script&lang=js"
export * from "./CartSideBar.vue?vue&type=script&lang=js"

import "./CartSideBar.vue?vue&type=style&index=0&id=9c9067b8&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__